const API_URL = process.env.NEXT_PUBLIC_API_URL || ''
const CZ_API_URL = process.env.NEXT_PUBLIC_CZ_API_URL || ''
const DE_API_URL = process.env.NEXT_PUBLIC_DE_API_URL || ''

export const API = {
  PL: API_URL,
  CZ: CZ_API_URL,
  DE: DE_API_URL,
} as const
